import Contract from "./Contract";

const Index = () => {

    
    return (
        <>
            <Contract title={"Remaining Sales Contracts"} settlementType={"5"}/>
        </>
    );
};

export default Index;
